/*
 *
 * Patient constants
 *
 */

export const DEFAULT_ACTION = 'src/Patient/DEFAULT_ACTION';
